var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"headerToolbar"}},[_c('User')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }